import React from 'react';
import { Award } from 'lucide-react';

const NismBadge = () => {
  return (
    <section className="bg-green-50 py-8 sm:py-10" data-testid="nism-badge-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-gradient-to-r from-green-50 to-white border-2 border-green-200 rounded-2xl p-5 sm:p-6 flex items-center gap-4 sm:gap-5 shadow-sm">
          <div className="w-12 h-12 sm:w-14 sm:h-14 bg-green-600 rounded-xl flex items-center justify-center flex-shrink-0">
            <Award className="h-6 w-6 sm:h-7 sm:w-7 text-white" strokeWidth={2.5} />
          </div>
          <div className="flex-1">
            <p className="text-xs sm:text-sm text-gray-500 mb-0.5">Personally founded & taught by</p>
            <strong className="block text-sm sm:text-base lg:text-lg font-bold text-gray-900 leading-snug">
              Deepak Singhai — NISM Certified Research Analyst (RA)
            </strong>
            <span className="block text-xs sm:text-sm text-green-700 font-semibold mt-0.5">
              National Institute of Securities Markets · Established by SEBI, Govt. of India
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NismBadge;
